import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_ENDPOINTS, axiosInstance } from "../../Api/apiConfig";

const EditBroker = ({
  onSaveSuccess,
  selectedData,
  setRefreshEditModal,
  refreshEditModal,
  userRole,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    setValue, // Added setValue from react-hook-form
  } = useForm();

  const [isLoading, setIsLoading] = useState(false);
  const [reloadTable, setReloadTable] = useState(false); // State variable to trigger table reload
  const [isRequestInProgress, setIsRequestInProgress] = useState(false);

  useEffect(() => {
    if (selectedData && refreshEditModal) {
      setIsLoading(true);
      setValue("brokerId", selectedData[0]);
      setValue("brokerName", selectedData[1]);
      setValue("mcNumber", selectedData[2]);
      setValue("brokerPhone", selectedData[3]);
      setValue("brokerAfterHours", selectedData[4]);
      setValue("brokerBillingEmail", selectedData[5]);
      setValue("brokerNotes", selectedData[6]);
      setValue("brokerStatus", selectedData[7]);
      setValue("brokerEmail", selectedData[8]);
      setValue("invoiceSubmittedThru", selectedData[9]);
      setValue("invoiceMethodPaid", selectedData[10]);
      setIsLoading(false);
    }
  }, [selectedData, reloadTable, refreshEditModal]);

  const onSubmit = async (data) => {
    if (isRequestInProgress) {
      return;
    }
    setIsRequestInProgress(true);
    let id = toast.loading("Updating Broker details.Please wait..."); // Update id inside the try block
    try {
      const formData = new FormData();

      Object.keys(data).forEach((val) => {
        if (data[val]) {
          formData.append(val, data[val]);
        }
      });

      await axiosInstance.patch(API_ENDPOINTS.BROKERS, formData);
      toast.update(id, {
        render: "Broker details updated successfully.",
        type: "success",
        isLoading: false,
        autoClose: 1500,
      });
      onSaveSuccess();
      reset();
      setReloadTable((prevReloadTable) => !prevReloadTable);
      document.getElementById("closeButtonEditBroker").click();
    } catch (error) {
      console.error("Error:", error);
      toast.update(id, {
        render: error.response.data.message,
        type: "error",
        isLoading: false,
        autoClose: 1500,
      });
    } finally {
      setIsRequestInProgress(false);
    }
  };

  return (
    <div
      className="modal fade"
      id="modalEditBroker"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fw-bold fs-5">Editing Broker</h1>
          </div>
          {!isLoading ? (
            <form onSubmit={handleSubmit(onSubmit)} className="modal-body">
              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label fw-bold">Name:</label>
                  <input
                    type="text"
                    className="form-control create-input"
                    {...register("brokerName", {
                      required: true,
                      maxLength: 255,
                    })}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label fw-bold">MC#</label>
                  <input
                    type="text"
                    className="form-control create-input"
                    {...register("mcNumber", { maxLength: 255 })}
                  />
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label fw-bold">Phone:</label>
                  <input
                    type="text"
                    className="form-control create-input"
                    {...register("brokerPhone", {
                      maxLength: 255,
                    })}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label fw-bold">After Hours:</label>
                  <input
                    type="text"
                    className="form-control create-input"
                    {...register("brokerAfterHours", { maxLength: 255 })}
                  />
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label fw-bold">Email:</label>
                  <input
                    type="text"
                    className="form-control create-input"
                    {...register("brokerEmail", { maxLength: 255 })}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label fw-bold">Status:</label>
                  <select
                    className="form-control create-input"
                    {...register("brokerStatus")}
                  >
                    <option value="Active">Active</option>
                    <option value="Disabled">Disabled</option>
                  </select>
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label fw-bold">
                    Invoice Submitted Thru:
                  </label>
                  <select
                    className="form-control create-input"
                    {...register("invoiceSubmittedThru")}
                  >
                    <option value="Email">Email</option>
                    <option value="Epay">Epay</option>
                    <option value="Triumphpay">Triumphpay</option>
                    <option value="Portal">Portal</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label fw-bold">Payment Method:</label>
                  <select
                    className="form-control create-input"
                    {...register("invoiceMethodPaid")}
                  >
                    <option value="ACH">ACH</option>
                    <option value="Check">Check</option>
                  </select>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-md-12">
                  <label className="form-label fw-bold">Billing Email:</label>
                  <input
                    type="text"
                    className="form-control create-input"
                    {...register("brokerBillingEmail", { maxLength: 255 })}
                  />
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-12">
                  <label className="form-label fw-bold">Broker Notes:</label>
                  <input
                    type="text"
                    className="form-control create-input"
                    {...register("brokerNotes", {})}
                  />
                </div>
              </div>

              <div>
                <button type="submit" className="btn reg-user-submit">
                  Submit
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={(e) => {
                    setRefreshEditModal(false);
                  }}
                  id="closeButtonEditBroker"
                >
                  Close
                </button>
              </div>
            </form>
          ) : (
            <>
              <div className="text-center">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default EditBroker;
